import React from 'react';

// eslint-disable-next-line no-unused-vars
import { useTranslation } from 'react-i18next';

import { withMediaQueries } from 'hoc/withMediaQueries';
import MainFont from 'ui/typography/mainFont';

import { ChargingEventsContainer, EventsWrapper, Title } from './style';

const ChargingEvents = () => {
  const { t } = useTranslation();

  return (
    <ChargingEventsContainer>
      <Title>
        <MainFont type="detailTitle">{t('latest_events')}</MainFont>
      </Title>
      <EventsWrapper />
    </ChargingEventsContainer>
  );
};

ChargingEvents.propTypes = {
  // State
  // ChargingEvents
};

export default withMediaQueries(ChargingEvents);
